module.exports = __webpack_public_path__ + "static/media/background_top_left_mobile.92cac1e4.png";